export default {
  GETTERS: {
    GET_PARAMS: 'REQUEST/GET_PARAMS',
    GET_NAMESPACE: 'REQUEST/GET_NAMESPACE',
    GET_CONTROLLER: 'REQUEST/GET_CONTROLLER',
    GET_ACTION: 'REQUEST/GET_ACTION',
    GET_ROUTE: 'REQUEST/GET_ROUTE',
    GET_PARSER: 'REQUEST/GET_PARSER'
  },
  MUTATIONS: {
    SET_PARAMS: 'REQUEST/SET_PARAMS',
    SET_ROUTE: 'REQUEST/SET_ROUTE',
    SET_PARSER: 'REQUEST/SET_PARSER'
  },
  ACTIONS: {
    SETUP_ROUTE: 'REQUEST/SETUP_ROUTE',
    PARSE_PARAMS: 'REQUEST/PARSE_PARAMS'
  }
}
